import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "use", "position"];
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import styled, { isTrellisTheme } from 'foundations-theming/utils';
import { getLocalizationSafeTextTransform } from '../../utils/styles';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { fwcColor } from 'foundations-theming/utils/fwc';
import { MERCURY_LAYER } from '../../constants';

// we have to omit position due to a naming conflict between the
// CSS property and the prop name
import { jsx as _jsx } from "react/jsx-runtime";
const backgroundColorMapping = {
  calypso: fwcColor('fwc-ribbon-fill-calypso'),
  'candy-apple': fwcColor('fwc-ribbon-fill-candy-apple'),
  heffalump: fwcColor('fwc-ribbon-fill-heffalump'),
  koala: fwcColor('fwc-ribbon-fill-koala'),
  lorax: fwcColor('fwc-ribbon-fill-lorax'),
  marigold: fwcColor('fwc-ribbon-fill-marigold'),
  norman: fwcColor('fwc-ribbon-fill-norman'),
  olaf: fwcColor('fwc-ribbon-fill-olaf'),
  oz: fwcColor('fwc-ribbon-fill-oz'),
  pantera: fwcColor('fwc-ribbon-fill-pantera'),
  sorbet: fwcColor('fwc-ribbon-fill-sorbet'),
  thunderdome: fwcColor('fwc-ribbon-fill-thunderdome'),
  beta: fwcColor('fwc-ribbon-fill-beta'),
  free: fwcColor('fwc-ribbon-fill-free'),
  new: fwcColor('fwc-ribbon-fill-new')
};
export const getBackgroundColorToken = use => {
  var _backgroundColorMappi;
  return (_backgroundColorMappi = backgroundColorMapping[use]) !== null && _backgroundColorMappi !== void 0 ? _backgroundColorMappi : fwcColor('fwc-ribbon-fill-new');
};
const StyledSpan = styled.span.withConfig({
  displayName: "Ribbon__StyledSpan"
})(({
  theme,
  $use = 'new',
  $position = 'right',
  $cssStyles
}) => {
  const tokenizedBackgroundColor = getBackgroundColorToken($use);
  const isTrellis = isTrellisTheme(theme);
  return Object.assign({
    position: 'absolute',
    top: '8px',
    zIndex: MERCURY_LAYER,
    boxShadow: theme.boxShadow['100'],
    padding: $position === 'right' ? `0 ${theme.space['200']} 0 ${theme.space['300']}` : `0 ${theme.space['300']} 0 ${theme.space['200']}`,
    borderRadius: $position === 'right' ? `${theme.borderRadius['400']} ${theme.borderRadius['100']} ${theme.borderRadius['100']} ${theme.borderRadius['400']}` : `${theme.borderRadius['100']} ${theme.borderRadius['400']} ${theme.borderRadius['400']} ${theme.borderRadius['100']}`
  }, $position === 'right' ? {
    right: '-4px'
  } : {
    left: '-4px'
  }, {
    // font styles
    color: $use === 'koala' ? theme.color['text-core-default'] : $use === 'marigold' ? theme.color[fwcColor('fwc-tag-text-marigold')] : theme.color['text-core-on-fill-default'],
    textAlign: 'center',
    textTransform: getLocalizationSafeTextTransform(isTrellis),
    verticalAlign: 'inherit',
    hyphens: 'manual'
  }, theme.typography['heading-25'], {
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',
    // colorStylesMixin
    backgroundColor: theme.color[tokenizedBackgroundColor],
    // badgeStylesMixin
    display: 'inline-block',
    lineHeight: '20px',
    minHeight: '20px'
  }, $cssStyles);
});
export const Ribbon = _ref => {
  let {
      children,
      use = 'new',
      position = 'right'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps,
    domProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledSpan, Object.assign({}, domProps, {
    "data-prevent-inherit-border-radius": "true",
    $use: use,
    $position: position,
    $cssStyles: cssStyles,
    [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: 'Ribbon',
    children: children
  }));
};
Ribbon.displayName = 'Ribbon';